// extracted by mini-css-extract-plugin
export default {"admin":"admin_admin__QZTp4","navbar":"admin_navbar__pTXYs","content":"admin_content__yRTyJ"};